import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageFacing() {
  const [facings, setFacings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [facingID, setFacingID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({ facing: "" });

  const columns = [
    { name: "S.No.", selector: (row) => row.sln, sortable: true },
    { name: "Facing", selector: (row) => row.facing, sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span title="Delete" onClick={() => handleDelete(row.id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const fetchAllFacings = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getFacings();
      const arr = res?.data?.map((ele, ind) => ({
        sln: ind + 1,
        facing: ele.facing,
        id: ele._id,
      }));
      setFacings(arr);
    } catch (error) {
      console.error("Error fetching facings:", error);
      toast.error("Failed to load facings!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllFacings();
  }, []);

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({ facing: row.facing });
    setFacingID(row.id);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Facing?",
      text: "Are you sure you want to delete this facing?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteFacing(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Facing has been deleted.", "success");
          fetchAllFacings();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete facing.", "error");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { facing: editData.facing };
      if (isEdit) {
        const res = await HomeService.updateFacing(facingID, data);
        if (res?.status) {
          toast.success("Facing updated successfully!");
          setIsEdit(false);
          setEditData({ facing: "" });
          fetchAllFacings();
        }
      }
    } catch (error) {
      toast.error("Failed to save facing.");
      console.error("Error saving facing:", error);
    }
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit && (
            <section className="chartBox_area">
              <h2>Edit Facing</h2>
              <hr />
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="facing">
                      Facing<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="facing"
                      className="form-control"
                      value={editData.facing}
                      onChange={(e) =>
                        setEditData({ ...editData, facing: e.target.value })
                      }
                      placeholder="Enter Facing"
                      required
                    />
                  </div>
                </div>
                <button type="submit" className="btn btn-primary mt-3">
                  Save Changes
                </button>
              </form>
            </section>
          )}

          <div className="mt-5">
            <div style={headLineStyle} className="page-headline">
              Manage Facings
            </div>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <DataTable
                columns={columns}
                data={facings}
                pagination
                responsive
                highlightOnHover
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageFacing;
